// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"857":"c0b2e19d","995":"cf809599"}[chunkId] + ".chunk.js";
};